import styled from 'styled-components';
import { PowerBIEmbed } from 'powerbi-client-react';

export const Container = styled.div`
  flex: 1;
  margin-top: -50px;
`;

export const Embedded = styled(PowerBIEmbed)``;
